

































import Vue from 'vue'
import Component from 'vue-class-component'

import AListCustom from '../../../../components/AListCustom/AListCustom.vue'
import AListCustomItem from '../../../../components/AListCustom/AListCustomItem.vue'
import RegexpReferenceTitle from './RegexpReferenceTitle.vue'

// eslint-disable-next-line @typescript-eslint/no-var-requires
const regexpDataEn = require('./regexp-reference_en.json')
// eslint-disable-next-line @typescript-eslint/no-var-requires
const regexpDataRu = require('./regexp-reference_ru.json')

@Component({
  components: {
    AListCustomItem,
    AListCustom,
    RegexpReferenceTitle,
  },
})
export default class RegexpReference extends Vue {
  get regexpData(): any {
    if (this.$i18n.locale === 'ru') {
      return regexpDataRu.items
    }
    return regexpDataEn.items
  }
}
